export default "__VITE_ASSET__C9xl2QDi__"